import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { ActiveUploadProvider } from './contexts/ActiveUploadContext';
import { DateRangeProvider } from './contexts/DateRangeContext';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import SettingsPage from './pages/SettingsPage';
import StateClientSummaryPage from './pages/StateClientSummaryPage';
import TeamMemberPerformancePage from './pages/TeamMemberPerformancePage';
import TeamMemberDetailPage from './pages/TeamMemberDetailPage';
import UploadHistoryPage from './pages/UploadHistoryPage';
import UploadPage from './pages/UploadPage';

function ProtectedShell() {
  return (
    <ProtectedRoute>
      <DateRangeProvider>
        <ActiveUploadProvider>
          <Layout />
        </ActiveUploadProvider>
      </DateRangeProvider>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedShell />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/team-performance" element={<TeamMemberPerformancePage />} />
        <Route path="/team-member-detail" element={<TeamMemberDetailPage />} />
        <Route path="/state-client-summary" element={<StateClientSummaryPage />} />
        <Route path="/upload" element={<ProtectedRoute adminOnly><UploadPage /></ProtectedRoute>} />
        <Route path="/history" element={<UploadHistoryPage />} />
        <Route path="/settings" element={<ProtectedRoute adminOnly><SettingsPage /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
